import { SnapshotVersion } from '@tiptap-pro/extension-snapshot'
import { StateCreator, createStore } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { IS_PROD_LIKE_ENVIRONMENT } from '@/constants/env'

export interface RichTextAreaStoreState {
  versions: SnapshotVersion[] | undefined
  setVersions: (versions: SnapshotVersion[]) => void
}

export type RichTextAreaStore = ReturnType<typeof createRichTextAreaStore>

const INIT_STORE: StateCreator<RichTextAreaStoreState> = (set, get) => ({
  versions: undefined,
  setVersions: (versions) => set({ versions }),
})

export const createRichTextAreaStore = () => {
  if (IS_PROD_LIKE_ENVIRONMENT) {
    return createStore<RichTextAreaStoreState, [['zustand/immer', never]]>(
      immer<RichTextAreaStoreState>((set, get, store) => ({
        ...INIT_STORE(set, get, store),
      })),
    )
  }

  return createStore<
    RichTextAreaStoreState,
    [['zustand/devtools', never], ['zustand/immer', never]]
  >(
    devtools(
      immer<RichTextAreaStoreState>((set, get, store) => ({
        ...INIT_STORE(set, get, store),
      })),
      {
        name: 'richTextAreaStore',
        store: `richTextArea`,
      },
    ),
  )
}
